module.exports = __webpack_public_path__ + "static/img/14.637350f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carrossel/14.png
// module id = wljF
// module chunks = 4